import React from 'react';

import { Box, Paragraph } from '@rover/kibble/core';
import type { ThemeTextColor } from '@rover/kibble/styles/themeTypes';

const LINE_HEIGHT = 24;

export type TruncatedTextProps = {
  children: string;
  numberOfLines?: number;
  textColor?: ThemeTextColor;
};

const TruncatedText = ({
  children,
  numberOfLines = 1,
  textColor = 'primary',
}: TruncatedTextProps): JSX.Element => {
  const paragraphStyle = {
    display: '-webkit-box',
    overflow: 'hidden',
    'white-space': 'pre-line',
    '-webkit-line-clamp': `${numberOfLines}`,
    '-webkit-box-orient': 'vertical',
  };

  return (
    <Box height={`${numberOfLines * LINE_HEIGHT}px`}>
      <Paragraph
        sx={paragraphStyle}
        webProps={{ maxWidth: '100%' }}
        marginBottom="0x"
        textColor={textColor}
      >
        {children}
      </Paragraph>
    </Box>
  );
};

export default TruncatedText;
